module.exports = __webpack_public_path__ + "img/Mediamodifier-Design-Template.4590f49b.png";